import React, { Component } from 'react';
import { DropdownButton, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PubSub from 'pubsub-js';

class Algorithms extends Component {

    constructor(props) {
        super(props);
        this.state = {
            singleSelection: "",
            autoSelect: true,
        };
        this.globalAlgorithms = [];
    }

    componentDidMount() {
        this.chartAlgoSelectedTrigger = PubSub.subscribe('chartAlgoSelectedTrigger', (topic, data) => {
            this.onSelectInput(data, true);
        });
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.chartAlgoSelectedTrigger);
    }


    onSelectInput = (e, comingFromTrigger) => {
        let algorithmName = e.target.value;
        let algorithmSelected = e.target.checked;

        if (!this.state.autoSelect && comingFromTrigger){
            return;
        }

        //let tmpAlgorithms = this.globalAlgorithms.filter(ind => ind.name !== algorithmName);
        let tmpAlgorithms = []; //Single selection
        console.log('Algorithms tmpAlgorithms', tmpAlgorithms, e, algorithmName, algorithmSelected);
        // if (algorithmSelected) {
            let tmpObj = { name: algorithmName, selected: algorithmSelected };
            tmpAlgorithms.push(tmpObj);
            this.globalAlgorithms.push(tmpObj);
        //}
        console.log('Algorithms tmpAlgorithms1', tmpAlgorithms);
        this.globalAlgorithms = tmpAlgorithms;
        console.log('Algorithms', e.target.value, e, e.target.checked, e.target.name, this.globalAlgorithms);
        PubSub.publish('chartAlgorithmsSelected', this.globalAlgorithms);

        //If its already selected, deselect it
        if (this.state.singleSelection === algorithmName.toUpperCase() && algorithmSelected === false) {
            this.setState({ singleSelection: '' });
        } else {
            this.setState({ singleSelection: algorithmName.toUpperCase() });
        }
    }

    onAutoSelectInput = (e) => {
        console.log('autoselect', e.target.checked, this.state.autoSelect);
        this.setState({ autoSelect: !this.state.autoSelect});
    }

    render() {
        return (
            <OverlayTrigger
            placement="left"
            overlay={<Tooltip id="button-tooltip-2">Autoselects the best backtested stratergy.  You can select any stratergy by turning off Auto Select Option
            </Tooltip>}
            >
            <DropdownButton id="algorithms" title={'Stratergy ' + this.state.singleSelection} size="sm">
                <Dropdown.Item href="#/turnOnOffAutoSelect">
                    <input type="checkbox" ref="inputElem" autoComplete="off" name="turnOnOffAutoSelect" placeholder="turnOnOffAutoSelect"
                        value="turnOnOffAutoSelect" onChange={this.onAutoSelectInput} checked={this.state.autoSelect === true}
                    /> Auto Select (On/Off)
                </Dropdown.Item>     
                <Dropdown.Divider />           
                <Dropdown.Item href="#/ema">
                    <input type="checkbox" ref="inputElem" autoComplete="off" name="ema" placeholder="EMA"
                        value="ema" onChange={this.onSelectInput} checked={this.state.singleSelection === "EMA"}
                    /> EMA Crossover
                </Dropdown.Item>
                <Dropdown.Item href="#/sma">
                    <input type="checkbox" ref="inputElem" autoComplete="off" name="sma" placeholder="SMA"
                        value="sma" onChange={this.onSelectInput} checked={this.state.singleSelection === "SMA"}
                    /> SMA Crossover
                </Dropdown.Item>
                {/* <Dropdown.Divider /> */}
                <Dropdown.Item href="#/macd">
                    <input type="checkbox" ref="inputElem" autoComplete="off" name="macd" placeholder="MACD"
                        value="macd" onChange={this.onSelectInput} checked={this.state.singleSelection === "MACD"}
                    /> MACD
                </Dropdown.Item>
                {/* <Dropdown.Divider />
                <Dropdown.Item href="#/bb">
                    <input type="checkbox" ref="inputElem" autoComplete="off" name="bb" placeholder="BB"
                        value="bb" onChange={this.onSelectInput} checked={this.state.singleSelection === "BB"}
                    /> Bollinger Band
                </Dropdown.Item> */}
                <Dropdown.Item href="#/rsi">
                    <input type="checkbox" ref="inputElem" autoComplete="off" name="rsi" placeholder="RSI"
                        value="rsi" onChange={this.onSelectInput} checked={this.state.singleSelection === "RSI"}
                    /> RSI
                </Dropdown.Item>
            </DropdownButton>
            </OverlayTrigger>
        )
    };
}

export default Algorithms;